/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */

export function transformPathToAnalyticFormat(pathname: string): string {
  return pathname === '/'
    ? 'signup:contacts-data'
    : pathname.replace('/', 'signup:').replaceAll('/', ':');
}
const handleAnalyticsError = (...args: any) =>
  console.error(`[analytics]`, ...args);

const logAnalyticsEvent = (
  eventType: 'view' | 'link',
  status: 'queued' | 'sent',
  data: unknown,
) => {
  if (import.meta.env.DEV) {
    console.log(
      `[utag][${eventType}][${status}][${new Date().toISOString()}]`,
      data,
    );
    /* eslint-enable no-console */
  }
};

/**
 * Tracks a page view.
 * @param data analytics payload.
 */
export function trackView(data: Record<string, string>) {
  try {
    const utag = window.utag;

    if (utag && typeof utag.view === 'function') {
      // Defer slightly in order to not slow down the event-loop with
      // synchronous analytics events during a critical synchronous rendering of
      // a view.
      setTimeout(() => {
        // 'utag' writes on the payload object we pass.
        // We perform a shallow copy to avoid issues.
        utag.view({ ...data });

        if (import.meta.env.DEV) {
          logAnalyticsEvent('view', 'sent', data);
        }
      }, 100);
    } else {
      const utagViewQueue =
        window.utag_queue_view ?? (window.utag_queue_view = []);

      utagViewQueue.push({ ...data });
      if (import.meta.env.DEV) {
        logAnalyticsEvent('view', 'queued', data);
      }
    }
  } catch (trackError) {
    handleAnalyticsError('[utag][view]', trackError, data);
  }
}

/**
 * Tracks a tap.
 * @param data analytics payload.
 */
export function trackTap(data: Record<string, string>) {
  try {
    const utag = window.utag;

    if (utag && typeof utag.link === 'function') {
      // 'utag' writes on the payload object we pass.
      // We perform a shallow copy to avoid issues.
      utag.link({ ...data });

      if (import.meta.env.DEV) {
        logAnalyticsEvent('link', 'sent', data);
      }
    } else {
      const utagLinkQueue =
        window.utag_queue_link ?? (window.utag_queue_link = []);

      utagLinkQueue.push({ ...data });
      if (import.meta.env.DEV) {
        logAnalyticsEvent('link', 'queued', data);
      }
    }
  } catch (trackError) {
    handleAnalyticsError('[utag][tap]', trackError, data);
  }
}

/**
 * Wraps an event handler and invokes the analytics tap event everytime
 * the function is invoked.
 * @param func A callback that handle
 * @param data analytics payload.
 * ```typescript
 *  const handleTrasnferReasonClick = React.useCallback(
 *    withTrackedTap(
 *      () => copyBankTransferInfoToClipboard(bankTransferReason),
 *      {
 *        event_name: 'campo_copia',
 *        field_name: 'causale',
 *      },
 *    ),
 *    [bankTransferReason],
 *  );
 * ```
 */
export function withTrackedTap<T extends Function>(
  func: T,
  data: Record<string, string>,
): T {
  const output: any = (...args: any[]) => {
    try {
      trackTap(data);
    } catch (err) {
      handleAnalyticsError(err);
    }

    return func(...args);
  };

  return output as T;
}
